import { render, staticRenderFns } from "./monograph.vue?vue&type=template&id=1fa49f3d&scoped=true"
import script from "./monograph.vue?vue&type=script&lang=js"
export * from "./monograph.vue?vue&type=script&lang=js"
import style0 from "./monograph.vue?vue&type=style&index=0&id=1fa49f3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa49f3d",
  null
  
)

export default component.exports